'use strict';

const baseDetails = require('richemont/product/detail');

/**
 * Sets the active dot in the desktop navigation based on the most visible image in the viewport.
 * Takes into account a sticky header and updates the active navigation element.
 */
function setImageDesktopDot() {
    let maxVisibleArea = 0;
    let visibleIndex = -1;
    const $navigationElements = $('.shots-navigation-element');
    const headerHeight = $('.experience-header').outerHeight() || 0;

    $('.pdp-image-row').each(function (index) {
        const rect = this.getBoundingClientRect();
        const visibleHeight = Math.max(0, Math.min(rect.bottom, $(window).height() - headerHeight) - Math.max(rect.top, 0));

        if (visibleHeight > maxVisibleArea) {
            maxVisibleArea = visibleHeight;
            visibleIndex = index;
        }
    });
    $navigationElements.eq(visibleIndex).addClass('shots-navigation-element-active').siblings().removeClass('shots-navigation-element-active');
}

baseDetails.imageSlickDesktop = function () {
    setImageDesktopDot();
    $(document).on('scrollend', setImageDesktopDot);
};

module.exports = baseDetails;
